import { schema } from "normalizr";

export const bannerPreviewSchema = new schema.Entity("bannerPreviews");